// Mock report generation service
let reports = {};

export function startReport(payload){
  const id = 'report_' + Date.now();
  reports[id] = { id, status:'generating', progress:0, payload, startedAt: Date.now() };
  return Promise.resolve({ id });
}

export function getReport(id){
  return Promise.resolve(reports[id]);
}

function advance(){
  Object.values(reports).forEach(r=>{
    if(r.status === 'generating'){
      r.progress = Math.min(100, r.progress + 12 + Math.random()*18);
      if(r.progress >= 100){
        r.progress = 100;
        r.status = 'ready';
        r.completedAt = Date.now();
        r.summary = {
          timeframe: r.payload.timeframe,
          sections: r.payload.sections.filter(Boolean).length,
          format: r.payload.format,
          issues: Math.floor(Math.random()*20),
          optimizations: Math.floor(Math.random()*10)
        };
        r.downloadUrls = {
          pdf: `/downloads/${r.id}.pdf`,
          csv: `/downloads/${r.id}.csv`,
          json: `/downloads/${r.id}.json`
        };
      }
    }
  });
  setTimeout(advance, 1600);
}
setTimeout(advance, 1600);
